'use client'
import { Heading } from '@/components/Heading'
import { Tab, Tabs } from '@/components/Tabs'
import { EshopRoutes } from '@/eshop/routes'
import Link from 'next/link'
import { PropsWithChildren, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const tabKeys = [
    'dashboard',
    'orders',
    'inferiororders',
    'invoices',
    'settings',
] as const

interface Props {
    currentTab: (typeof tabKeys)[number]
    isAdmin: boolean
}

interface MyTab {
    key: (typeof tabKeys)[number]
    label: React.ReactElement<any>
    content: null
}

export default function UserSection({
    children,
    currentTab,
    isAdmin,
}: PropsWithChildren<Props>) {
    const { t } = useTranslation()

    const tabs: MyTab[] = useMemo(() => {
        let tabs: MyTab[] = [
            {
                key: 'dashboard',
                label: (
                    <Link href={EshopRoutes.user}>
                        {t('eshop.usersettings.header.dashboard')}
                    </Link>
                ),
                content: null,
            },
            {
                key: 'orders',
                label: (
                    <Link href={EshopRoutes.userOrders}>
                        {t('eshop.usersettings.header.orders')}
                    </Link>
                ),
                content: null,
            },
            {
                key: 'inferiororders',
                label: (
                    <Link href={EshopRoutes.inferiorOrders}>
                        {t('eshop.usersettings.header.userOrders')}
                    </Link>
                ),
                content: null,
            },
            {
                key: 'invoices',
                label: (
                    <Link href={EshopRoutes.invoices}>
                        {t('eshop.usersettings.header.invoices')}
                    </Link>
                ),
                content: null,
            },
            {
                key: 'settings',
                label: (
                    <Link href={EshopRoutes.userSettings}>
                        {t('eshop.usersettings.header.settings')}
                    </Link>
                ),
                content: null,
            },
        ]

        if (!isAdmin) {
            tabs = tabs.filter((t) => t.key !== 'inferiororders')
        }

        return tabs
    }, [t])

    const userTabs = useMemo(
        () =>
            tabs.map((tab) => {
                if (tab.key === currentTab) {
                    return {
                        ...tab,
                        content: children,
                    }
                }
                return tab
            }),
        [currentTab, children]
    )

    return (
        <>
            <Heading text="Administrace" tag="h2" className="text-2xl mb-10" />
            <Tabs
                tabs={userTabs as any as Tab[]}
                defaultActive={currentTab}
                fullWidthContent
            />
        </>
    )
}
